module.exports = __webpack_public_path__ + "static/media/empretec-3.1915026c.jpg";